// extracted by mini-css-extract-plugin
export default {"description":"DescriptionListItemDescription-description-IZlGY"};